export default __webpack_public_path__ + "static/media/icon-i.c44910fb.svg";